import moment from 'moment';
import 'moment-timezone';
import 'moment-duration-format';

// import { DEFAULT_TZ, DEFAULT_LANG } from '@/constants';
import store from '@/store/index';

export const getUserTimezone = () => {
  const currentUser = store.getters['entities/users/currentUser'];
  const browserTimezone = moment.tz.guess();
  const timezone = currentUser.timezone || browserTimezone;
  return timezone;
};

export const formatTime = (time, format = null) => {
  if (!time) return 'Not a valid time';

  const currentUser = store.getters['entities/users/currentUser'];
  const parsedTime = moment(time);

  if (currentUser && currentUser.timezone) {
    return parsedTime.format(format || 'hh:mm a');
  }
  return parsedTime.format(format || 'hh:mm a');
};

export const formatTimeNoTZ = (time, format = null) => {
  if (!time) return 'Not a valid time';

  // const currentUser = store.getters['entities/users/currentUser'];
  const parsedTime = moment(time);

  return parsedTime.format(format || 'hh:mm a');
};

export const timeDifference = (startTime, endTime) => {
  const diff = moment(startTime).diff(moment(endTime));

  return moment.duration(Math.abs(diff)).format('h [h], m [min]');
};

export const getEndTime = (startTime, len) => moment(startTime).add(len, 'hours');

export const formatDiff = (diff, type = null) => moment.duration(diff, type).format('h [h], m [min]');
// export const formatDiff = (diff, type = null) => moment.duration(diff, type).format('h [h], m [min], s [sec]');

moment.locale('precise-en', {
  relativeTime: {
    future: 'in %s',
    past: '%s ago',
    s: '%d seconds',
    m: 'a minute',
    mm: '%d minutes',
    h: 'an hour',
    hh: '%d hours',
    d: 'a day',
    dd: '%d days',
    M: 'a month',
    MM: '%d months',
    y: 'a year',
    yy: '%d years',
  },
});



// WEBPACK FOOTER //
// ./src/filters/time.js